<template>
  <div>
    <div class="text-title mb-2">Categorias</div>
    
    <div 
      class="categorias-wrapper" 
      ref="scrollContainer"
      @mousedown="startDragging"
      @mouseleave="stopDragging"
      @mouseup="stopDragging"
      @mousemove="onMouseMove"
    >
      <div 
        v-for="cat in lista" :key="cat.id"
        class="btn-categoria mt-2" 
        :class="{'btn-categoria-sel' : cat.ativo}"
        @click="$emit('selecionar', cat.id)"
      >
        {{ cat.nome }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FiltroCategorias',
  props: {
    lista: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isDragging: false,
      startX: 0,
      scrollLeft: 0
    }
  },
  methods: {
    startDragging(e) {
      // Só inicia o arraste se a tela for mobile (ex: < 768px)
      if (window.innerWidth > 768) return; 
      
      this.isDragging = true;
      this.startX = e.pageX - this.$refs.scrollContainer.offsetLeft;
      this.scrollLeft = this.$refs.scrollContainer.scrollLeft;
    },
    stopDragging() {
      this.isDragging = false;
    },
    onMouseMove(e) {
      // Só processa o movimento se estiver arrastando e for mobile
      if (!this.isDragging || window.innerWidth > 768) return;
      
      e.preventDefault();
      const x = e.pageX - this.$refs.scrollContainer.offsetLeft;
      const walk = (x - this.startX) * 2;
      this.$refs.scrollContainer.scrollLeft = this.scrollLeft - walk;
    }
  }
}
</script>

<style scoped>
  .text-title { 
      font-size: 20px; 
      color: #212529; 
      font-family: "Trebuchet MS", sans-serif;
  }
  .btn-categoria {
    display: block; 
    width: 100%;
    padding: 8px 16px;
    background: #FFF;
    cursor: pointer;
    transition: 0.2s;
    font-family: "Trebuchet MS", sans-serif;
    font-size: 16px;
    margin-top: 8px;
  }
  .btn-categoria:hover { 
    font-weight: bold !important; 
  }
  .btn-categoria-sel {    
    background: #CDDDDC;
    color: #00423E;
    font-weight: 700;
  }
  .categorias-wrapper {
    display: block; 
    overflow: visible; 
    cursor: default;
  }
  .categorias-wrapper:active {
    cursor: grabbing;
  }

/* Media query para comportamento de Carrossel no Mobile */
@media (max-width: 768px) {
  .categorias-wrapper {
      display: flex !important;
      flex-direction: row !important;
      flex-wrap: nowrap !important;
      overflow-x: auto !important;
      overflow-y: hidden !important;
      touch-action: pan-x !important; 
      -webkit-overflow-scrolling: touch !important;
      gap: 12px;
      padding: 10px 5px !important;
      cursor: grab; 
  }
  .categorias-wrapper:active {
    cursor: grabbing;
  }
  .btn-categoria {
      display: inline-block !important;
      flex: 0 0 auto !important; 
      width: auto !important; 
      margin-top: 0 !important;
      white-space: nowrap !important;
      user-select: none !important;
      -webkit-user-select: none !important;
      pointer-events: auto !important; 
      -webkit-user-drag: none !important;
      padding: 5px 10px;
      border-radius: 5px;
  }
}
</style>

<style>
@media (max-width: 768px) {
    
    .categorias-wrapper::-webkit-scrollbar {
        width: 0px !important;
        height: 0px !important;
        background: transparent !important;
        display: none !important;
    }

    .categorias-wrapper {
        scrollbar-width: none !important; /* Firefox */
        -ms-overflow-style: none !important; /* IE/Edge */
        margin-bottom: 20px;
    }
}
</style>